import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/keji-shuma', label: '品牌分类' },
    { to: '/category/keji-shuma', label: '国货文章' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-flag-2-fill text-white text-lg md:text-xl"></i>
            </div>
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950 whitespace-nowrap">
              国产第一页
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              品牌入驻
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-950"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className={`text-sm font-medium py-2 transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-center py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              品牌入驻
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}